import * as actions from "../actions/Type";
import primary_logo from "../assets/images/m_1.png";
import logo from "../assets/images/m_1.png";
import footer_logo from "../assets/images/m_4.png";
import primary_logo_bill from "../assets/images/m_1.png";
import footer_logo_bill from "../assets/images/m_4.png";
const intialState = {
  lang: "krd",
  primarycolor: "#295a68",
  secondarycolor: "#295a68",
  thirdcolor: "#000",
  primary_logo: primary_logo,
  footer_logo: footer_logo,
  logo_print_list: primary_logo,
  logo: logo,
  primary_logo_bill,
  footer_logo_bill,
  name_en: "MRC RealEstate Company",
  name_arb: "شرکة عقارات MRC",
  name_krd: "کۆمپانیای عقارات MRC",
};
const HelperReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.CHANGE_LANGE_KURDISH:
      return {
        ...state,
        lang: action.payload,
      };
    case actions.CHANGE_LANGE_ENGLISH:
      return {
        ...state,
        lang: action.payload,
      };
    case actions.CHANGE_LANGE_ARABIC:
      return {
        ...state,
        lang: action.payload,
      };
    default:
      return { ...state };
  }
};

export default HelperReducer;
